import { WebSocketContext } from '@/contexts/WebSocketContext';
import { BET_SOURCE_MOBILE } from '@/models/BetSource';
import {
    CMDPsNbsBet,
    CMDPsNewBlackjackMakeDecision,
    CMDPsRuleChange,
} from '@/models/cmd/live';
import { CMDBet } from '@/models/cmd/live/CMDBet';
import { BetType } from '@/models/games/blackjack2/enums/BetType';
import {
    DecisionCommandType,
    DecisionType,
} from '@/models/games/blackjack2/enums/DecisionState';
import { GameState as Blackjack2GameState } from '@/models/games/blackjack2/enums/GameState';
import { BetSeatIndex } from '@/models/games/blackjack2/SeatPlayerInfo';
import { GameState } from '@/models/games/enums/GameState';
import { BetFormat } from '@/models/host/BetAmount';
import { getHostById } from '@/modules/host/slice';
import { getHostLiveDataByHostId } from '@/modules/hostLive/slice';
import {
    getMainLimitRedState,
    getMainPlayerState,
} from '@/modules/main/selector';
import { getSeatHands } from '@/modules/rwdGame/blackjack2/slice/handSlice';
import { getBetSeats } from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import { RootState } from '@/store/store';
import { useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

// const hostID = 536;
// const toSeat = [1, 4, 7];
const isBetBehind = false;

// window.sessionStorage.setItem('bjRobot', bjRobot);
export type BJRobotProp = {
    hostID: number;
    toSeat: Array<number>;
};
export const TmpBJRobot = ({ hostID, toSeat }: BJRobotProp) => {
    const { sendCommand } = useContext(WebSocketContext);
    const changedRule = useRef<boolean>(false);
    const [minBet, setMinBet] = useState<number>(0);
    const limitRedByGameType = useSelector(getMainLimitRedState);
    const { Id: PlayerId } = useSelector(getMainPlayerState);
    // const betSource = useBetSource();
    const seatHands = useSelector((state: RootState) =>
        getSeatHands(state, hostID)
    );
    const seatInfos = useSelector((state: RootState) =>
        getBetSeats(state, hostID)
    );

    const { CurrentState, CurrentResult } = useSelector((state: RootState) =>
        getHostLiveDataByHostId(state, hostID)
    );
    const { GameType, Multiplier } = useSelector((state: RootState) =>
        getHostById(state, hostID)
    );
    useEffect(() => {
        console.log('??? Seat', seatInfos);
        if (isBetBehind) {
            if (seatInfos) {
                if (toSeat.length == 0) {
                    const random = Math.floor(Math.random() * 7) + 1;
                    let tmp = `Seat${random}` as BetSeatIndex;
                    if (seatInfos[tmp] && seatInfos[tmp].SeatBet > 0) {
                        betBehind(random);
                    }
                } else {
                    for (let i = 0; i < toSeat.length; i++) {
                        let tmp = `Seat${toSeat[i]}` as BetSeatIndex;
                        if (seatInfos[tmp] && seatInfos[tmp].SeatBet > 0) {
                            betBehind(toSeat[i]);
                        }
                    }
                }
            }
        }
    }, [seatInfos]);
    useEffect(() => {
        console.log('??? Hand', seatHands);
    }, [seatHands]);
    useEffect(() => {
        const limitRedByGame = limitRedByGameType.BetRuleByGameType?.find(
            lr => lr.GameType === GameType
        );
        if (limitRedByGame) {
            const limitRed = limitRedByGame.BetRule;
            if (limitRed.length > 0) {
                // if the are not selected limit, set the first limit in limitReds
                let selectedLimitRed =
                    limitRed.find(lr => lr.Selected === 1) || limitRed[0];
                if (!selectedLimitRed && limitRedByGame.RuleToSelect) {
                    selectedLimitRed = limitRedByGame.RuleToSelect;
                }
                if (!changedRule.current) {
                    const cmd = new CMDPsRuleChange();
                    cmd.GameType = GameType;
                    cmd.HostID = hostID;
                    cmd.RuleIndex = selectedLimitRed.RuleID;
                    sendCommand(cmd);
                    changedRule.current = true;
                }
                setMinBet(selectedLimitRed.MinBet);
            }
        }
    }, [limitRedByGameType, GameType]);
    // let test = false;
    useEffect(() => {
        const state = CurrentState as number;
        switch (state) {
            case GameState.Betting:
                // testing();
                // if (test) {
                startBet();
                // }
                break;
            case Blackjack2GameState.Decision:
                if (!isBetBehind) {
                    makeDecision();
                }
                break;
            case Blackjack2GameState.Insurance:
                doDecision(DecisionType.Insurance);
                break;
            case Blackjack2GameState.FollowDecision:
                doFollow();
                break;
        }
    }, [seatInfos?.DecisionStateStep]);
    const doDecision = (decision: DecisionType) => {
        if (CurrentResult) {
            const cmd = new CMDPsNewBlackjackMakeDecision();
            // cmd.BetSource = betSource;
            cmd.GameID = CurrentResult.GameID;
            cmd.Decision = decision;
            cmd.Seat = seatHands.ActionSeat;
            cmd.Type = DecisionCommandType.Decision;
            sendCommand(cmd);
        }
    };
    const doFollow = () => {
        const seat = `Seat${seatHands.ActionSeat}` as BetSeatIndex;
        const hand = seatHands.ActionHand == 1 ? 'hand1' : 'hand2';
        if (CurrentResult) {
            const cmd = new CMDPsNewBlackjackMakeDecision();
            // cmd.BetSource = betSource;
            cmd.GameID = CurrentResult.GameID;
            cmd.Decision = seatHands[seat][hand].last_decision;
            cmd.Seat = seatHands.ActionSeat;
            cmd.Type = DecisionCommandType.FollowDecision;
            sendCommand(cmd);
        }
    };
    const makeDecision = () => {
        const seat = `Seat${seatHands.ActionSeat}` as BetSeatIndex;
        console.log(
            '??? makeDecision',
            CurrentResult,
            seat,
            seatInfos[seat],
            PlayerId,
            seatHands[seat]
        );
        if (seatInfos[seat]?.PlayerID == PlayerId) {
            const hand = seatHands.ActionHand == 1 ? 'hand1' : 'hand2';
            const ds = seatHands[seat][hand].allow_decision;
            const point = Number(seatHands[seat][hand].display_txt);
            console.log('??? allow_decision', ds, point);
            let decision = ds[0];
            if (ds.indexOf(DecisionType.Split) >= 0) {
                decision = DecisionType.Split;
            } else if (
                ds.indexOf(DecisionType.DoubleDown) >= 0 &&
                !isNaN(point) &&
                point < 11
            ) {
                decision = DecisionType.DoubleDown;
            } else if (
                ds.indexOf(DecisionType.Surrender) >= 0 &&
                !isNaN(point) &&
                point == 15
            ) {
                decision = DecisionType.Surrender;
            } else if (
                ds.indexOf(DecisionType.Hit) >= 0 &&
                !isNaN(point) &&
                point < 18
            ) {
                decision = DecisionType.Hit;
            } else if (ds.indexOf(DecisionType.Stand) >= 0) {
                decision = DecisionType.Stand;
            }
            doDecision(decision);
        }
    };
    const startBet = () => {
        console.log('??? startBet', CurrentResult, minBet);
        if (CurrentResult && minBet > 0 && Multiplier) {
            const cmd = new CMDPsNbsBet();
            cmd.gameID = CurrentResult.GameID;
            cmd.BetSource = BET_SOURCE_MOBILE;
            cmd.betFormat = BetFormat.AUTO_BET;
            cmd.betSeqID = 1;
            cmd.remark = '';

            if (toSeat.length == 0) {
                let tmpArr = [];
                for (let i = 0; i < 2; i++) {
                    const random = Math.floor(Math.random() * 7) + 1;
                    let tmp = `Seat${random}` as BetSeatIndex;
                    if (
                        seatInfos[tmp] &&
                        seatInfos[tmp].SeatBet == 0 &&
                        tmpArr.indexOf(random) < 0
                    ) {
                        let cmdBet = new CMDBet();
                        cmdBet.betType = 100 + random;
                        cmdBet.betAmount = minBet * Multiplier;
                        cmd.bets.push(cmdBet);
                        tmpArr.push(random);
                    }
                }
            } else {
                for (let i = 0; i < toSeat.length; i++) {
                    let cmdBet = new CMDBet();
                    cmdBet.betType = 100 + toSeat[i];
                    cmdBet.betAmount = minBet * Multiplier;
                    cmd.bets.push(cmdBet);
                }
            }
            if (cmd.bets.length > 0) {
                sendCommand(cmd);
            }
        }
    };

    // const testing = () => {
    //     if (CurrentResult && minBet > 0 && Multiplier) {
    //         const cmd = new CMDPsNbsBet();
    //         cmd.gameID = CurrentResult.GameID;
    //         cmd.BetSource = BET_SOURCE_MOBILE;
    //         cmd.betFormat = BetFormat.AUTO_BET;
    //         cmd.betSeqID = 2;
    //         cmd.remark = '';
    //         for (let i = 0; i < 2; i++) {
    //             let cmdBet = new CMDBet();
    //             cmdBet.betType = 100 + i + 3;
    //             cmdBet.betAmount = minBet * Multiplier;
    //             cmd.bets.push(cmdBet);
    //         }
    //         sendCommand(cmd);

    //         setTimeout(() => {
    //             const cmd = new CMDPsNbsBet();
    //             cmd.gameID = CurrentResult.GameID;
    //             cmd.BetSource = BET_SOURCE_MOBILE;
    //             cmd.betFormat = BetFormat.AUTO_BET;
    //             cmd.betSeqID = 1;
    //             cmd.remark = '';
    //             for (let i = 0; i < 2; i++) {
    //                 let cmdBet = new CMDBet();
    //                 cmdBet.betType = 100 + i + 3;
    //                 cmdBet.betAmount = minBet * Multiplier * 2;
    //                 cmd.bets.push(cmdBet);
    //             }
    //             sendCommand(cmd);
    //         }, 1000);
    //     }
    // };
    const betBehind = (seat: number) => {
        console.log('??? betBehind', CurrentResult, minBet);
        if (CurrentResult && minBet > 0) {
            const cmd = new CMDPsNbsBet();
            cmd.gameID = CurrentResult.GameID;
            cmd.BetSource = BET_SOURCE_MOBILE;
            cmd.betFormat = BetFormat.AUTO_BET;
            cmd.betSeqID = 1;
            cmd.remark = '';

            let cmdBet = new CMDBet();
            cmdBet.betType = BetType.BJBB_Split1_Start + seat;
            cmdBet.betAmount = minBet;
            cmd.bets.push(cmdBet);

            sendCommand(cmd);
        }
    };
    return <div style={{ backgroundColor: '#FF0000' }}>Robot 運行中</div>;
};
